import { PAGE_LINKS } from './commonConsts'

class EnvHelper {
  get extensionPrefix() {
    return 'huixie'
  }

  get isProd() {
    return process.env.NODE_ENV === 'production'
  }

  get productName() {
    return '会写'
  }

  get host() {
    return process.env.REACT_APP_HOST
  }

  get webHost() {
    return process.env.REACT_APP_WEB_HOST
  }

  get apiHost() {
    return this.webHost
  }

  get apiBasePath() {
    return '/byy/workbench_server'
  }

  get pptHost() {
    return process.env.REACT_APP_PPT_WEB_HOST
  }

  get wxAppId() {
    return process.env.REACT_APP_WX_APPID
  }

  get wxLoginUrl() {
    const url = encodeURIComponent(`${this.webHost}${PAGE_LINKS.wxLogin}`)
    // return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.wxAppId}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=0#wechat_redirect`

    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.wxAppId}&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=0#wechat_redirect`
  }
}

export const envHelper = new EnvHelper()
